module.exports = __webpack_public_path__ + "img/Solutions-OnlineWillCreation.209b4058.jpg";